// extracted by mini-css-extract-plugin
module.exports = {"slide":"calendar_slide_1dhMH","slide-reverse":"calendar_slide-reverse_dYlUZ","tab":"calendar_tab_1UMd3","wrap":"calendar_wrap_2nEcB","mobile":"calendar_mobile_1UY42"};